export default [
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Afghanistan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Albania.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Algeria.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Angola.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Antigua-and-barbuda.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Argentina.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Armenia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Australia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Austria.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Azerbaijan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bahamas-the.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bahrain.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bangladesh.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Barbados.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Belarus.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Belgium.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Belize.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Benin.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bhutan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bolivia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bosnia-and-herzegovina.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Botswana.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Brazil.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Brunei-darussalam.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Bulgaria.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Burkina-faso.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Burundi.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Cape-verde.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Cambodia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Cameroon.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Canada.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Central-african-republic.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Chad.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Chile.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/China.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Colombia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Comoros.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Congo-dem-rep.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Congo-rep.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Costa-rica.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Cote-divoire.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Croatia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Cyprus.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Czech-republic.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Denmark.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Djibouti.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Dominica.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Dominican-republic.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Ecuador.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Egypt-arab-rep.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/El-salvador.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Equatorial-guinea.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Eritrea.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Estonia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Eswatini.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Ethiopia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Fiji.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Finland.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/France.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Gabon.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Gambia-the.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Georgia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Germany.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Ghana.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Greece.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Grenada.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Guatemala.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Guinea.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Guinea-bissau.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Guyana.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Haiti.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Honduras.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Hong-kong-sar-china.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Hungary.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Iceland.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/India.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Indonesia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Iran-islamic-rep.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Iraq.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Ireland.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Israel.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Italy.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Jamaica.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Japan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Jordan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Kazakhstan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Kenya.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Kiribati.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Korea-rep.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Kosovo.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Kuwait.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Kyrgyz-republic.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Lao-pdr.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Latvia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Lebanon.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Lesotho.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Liberia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Libya.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Lithuania.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Luxembourg.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Madagascar.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Malawi.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Malaysia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Maldives.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Mali.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Malta.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Marshall-islands.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Mauritania.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Mauritius.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Mexico.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Micronesia-fed-sts.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Moldova.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Mongolia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Montenegro.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Morocco.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Mozambique.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Myanmar.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Namibia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Nepal.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Netherlands.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/New-zealand.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Nicaragua.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Niger.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Nigeria.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/North-macedonia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Norway.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Oman.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Pakistan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Palau.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Panama.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Papua-new-guinea.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Paraguay.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Peru.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Philippines.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Poland.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Portugal.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Puerto-rico.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Qatar.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Romania.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Russian-federation.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Rwanda.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Samoa.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/San-marino.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Sao-tome-and-principe.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Saudi-arabia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Senegal.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Serbia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Seychelles.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Sierra-leone.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Singapore.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Slovak-republic.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Slovenia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Solomon-islands.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Somalia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/South-africa.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/South-sudan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Spain.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Sri-lanka.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/St-kitts-and-nevis.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/St-lucia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/St-vincent-and-the-grenadines.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Sudan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Suriname.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Sweden.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Switzerland.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Syrian-arab-republic.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Taiwan-china.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Tajikistan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Tanzania.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Thailand.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Timor-leste.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Togo.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Tonga.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Trinidad-and-tobago.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Tunisia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Turkey.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Uganda.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Ukraine.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/United-arab-emirates.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/United-kingdom.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/United-states.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Uruguay.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Uzbekistan.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Vanuatu.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Venezuela-rb.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Viet-nam.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/West-bank-and-gaza.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Yemen-rep.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Zambia.pdf",
  },
  {
    pdf: "https://wbl.worldbank.org/content/dam/documents/wbl/2024/snapshots/Zimbabwe.pdf",
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/home/home/pdfs.ts